export const SOLUTIONS = [
    {
        id: 1,
        title: 'Protección de patrimonio',
        subtitle: 'Protegemos tu legado con estructuras sólidas y coberturas internacionales',
        description: `La solidez de un legado comienza con la mitigación de riesgos. Diseñamos soluciones de protección patrimonial que trascienden fronteras y escenarios, resguardando no solo lo que ya has construido, sino también lo que proyectas alcanzar. Nuestro enfoque integra estructuras legales, planificación sucesoria y coberturas de alcance internacional, asegurando que tus seres queridos cuenten con tranquilidad financiera en cualquier circunstancia`,
        image: 'assets/images/proteccion.webp',
        icon: 'assets/svg/icon-money.svg',
        bullets: [
            {
                icon: 'assets/svg/icon-graph.svg',
                name: 'Estructuras legales internacionales'
            },
            {
                icon: 'assets/svg/icon-linear.svg',
                name: 'Cobertura sin exclusiones arbitrarias'
            },
            {
                icon: 'assets/svg/icon-chart.svg',
                name: 'Planes que protegen presente y futuro'
            }
        ]
    },
    {
        id: 2,
        title: 'Construcción de patrimonio',
        subtitle: 'Protegemos tu legado con estructuras sólidas y coberturas internacionales',
        description: `La solidez de un legado comienza con la mitigación de riesgos. Diseñamos soluciones de protección patrimonial que trascienden fronteras y escenarios, resguardando no solo lo que ya has construido, sino también lo que proyectas alcanzar. Nuestro enfoque integra estructuras legales, planificación sucesoria y coberturas de alcance internacional, asegurando que tus seres queridos cuenten con tranquilidad financiera en cualquier circunstancia`,
        image: 'assets/images/construccion.webp',
        icon: 'assets/svg/icon-linear.svg',
        bullets: [
            {
                icon: 'assets/svg/icon-graph.svg',
                name: 'Estructuras legales internacionales'
            },
            {
                icon: 'assets/svg/icon-linear.svg',
                name: 'Cobertura sin exclusiones arbitrarias'
            },
            {
                icon: 'assets/svg/icon-chart.svg',
                name: 'Planes que protegen presente y futuro'
            }
        ]
    },
    {
        id: 3,
        title: 'Gestión de patrimonio',
        subtitle: 'Protegemos tu legado con estructuras sólidas y coberturas internacionales',
        description: `La solidez de un legado comienza con la mitigación de riesgos. Diseñamos soluciones de protección patrimonial que trascienden fronteras y escenarios, resguardando no solo lo que ya has construido, sino también lo que proyectas alcanzar. Nuestro enfoque integra estructuras legales, planificación sucesoria y coberturas de alcance internacional, asegurando que tus seres queridos cuenten con tranquilidad financiera en cualquier circunstancia`,
        image: 'assets/images/gestion.webp',
        icon: 'assets/svg/icon-money.svg',
        bullets: [
            {
                icon: 'assets/svg/icon-graph.svg',
                name: 'Estructuras legales internacionales'
            },
            {
                icon: 'assets/svg/icon-linear.svg',
                name: 'Cobertura sin exclusiones arbitrarias'
            },
            {
                icon: 'assets/svg/icon-chart.svg',
                name: 'Planes que protegen presente y futuro'
            }
        ]
    }
];